import React, { useState, useEffect } from "react";
import assets from "../assets/imgs"; // 아이콘 가져오는 경로 맞게 조정해야 해

function InfoBox({ size = 24, description }) {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  // ESC 키로 모달 닫기
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  const isHtml = typeof description === "string" && /<\/?[a-z][\s\S]*>/i.test(description);

  return (
    <>
      {/* Info 아이콘 */}
      <div style={{...styles.infoIcon, 
                    width: `${size}px`,
                    height: `${size}px`,}} onClick={openModal}>
        <assets.icons.info />
      </div>

      {/* 모달 */}
      {showModal && (
        <div style={styles.overlay} onClick={(e) => {
          if (e.target === e.currentTarget) {
            closeModal();
          }
        }}>
          <div style={styles.modal}>
            <div style={{display: "flex", justifyContent: 'flex-end', width:"100%", cursor:"pointer"}} onClick={closeModal}><assets.icons.icon_x/></div>
            {isHtml ? (
              <div dangerouslySetInnerHTML={{ __html: description }} />
            ) : (
              <div>{description}</div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

const styles = {
  infoIcon: {
    cursor: "pointer",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "25px",
    padding: "20px 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "50px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    position: "relative",
    flexDirection: "column",
  },
};

export default InfoBox;